<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
        <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              To dial an extension from outside dial 876-963-EXT#
            </p>
          </div>
        </div>-->

        <div class="uk-padding ">
          <div class="uk-container uk-container-small">
            <h1 class="uk-heading-line uk-text-center specHeading">Campus Office Hours</h1>
            <p class="uk-text-muted">The offices on campus are here to serve all students as best as they can. Please be advised of the following <span class="uk-text-bold">Campus Office Opening Hours.</span></p>

            <p class="uk-text-danger uk-text-small">
              Please note: All offices apart from NCU Media closes at 1:30 on a Friday
            </p>
           <div class="uk-overflow-auto">
             <table class="uk-table uk-table-divider uk-table-striped  uk-table-small">
               <thead>
               <tr class="uk-background-secondary uk-light">
                 <th>Department</th>
                 <th>Extension</th>
                 <th>Opening Hours</th>
               </tr>
               </thead>
               <tbody class="uk-text-small">
               <tr>
                 <td>Academic Administration</td>
                 <td>7157</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Accreditation</td>
                 <td>7044</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Admin conference Room</td>
                 <td>7186</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>All Superette Brands</td>
                 <td>7023</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Admission & Recruitment</td>
                 <td>7250</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Behavioural Science</td>
                 <td>7356</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Bookstore</td>
                 <td>7781</td>
                 <td>8:00 a.m. – 5:00p.m.</td>
               </tr>
               <tr>
                 <td>Business Office</td>
                 <td>7217</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Cafeteria</td>
                 <td>7271</td>
                 <td>7:00 a.m. – 6:00 p.m.</td>
               </tr>
               <tr>
                 <td>Campus Upkeep</td>
                 <td>7785</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Career and Employment services</td>
                 <td>7442</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>CCMPR</td>
                 <td>7155</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Chaplaincy Services</td>
                 <td>7196</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Communication Studies</td>
                 <td>7445</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Community Music School</td>
                 <td>7749</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Finance Department</td>
                 <td>7227</td>
                 <td>8:00 am - 4:30 pm</td>
               </tr>
               <tr>
                 <td>Finance and Facilities</td>
                 <td>7016</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Health Services</td>
                 <td>7477</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Hilltop Hotel and Conference Center</td>
                 <td>7013</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Hiram Walter Resource Center</td>
                 <td>7074</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>HR Department</td>
                 <td>7168</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Humanities</td>
                 <td>7463</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>

               <tr>
                 <td>NCU Bookstore</td>
                 <td>7781</td>
                 <td>6:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>NCU Media</td>
                 <td>7711</td>
                 <td>8:00 a.m. – 7:30 p.m.</td>
               </tr>
               <!--<tr>
                 <td>Office of </td>
                 <td>7157</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>-->




               <tr>
                 <td>News, Sport & Current Affairs</td>
                 <td>7718</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Pastors Office</td>
                 <td>7326</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Post Office</td>
                 <td>7021</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Press</td>
                 <td>7137</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Purchasing</td>
                 <td>7208</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Repairs and Maintenance</td>
                 <td>7133</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Sales and Marketing</td>
                 <td>7724</td>
                 <td>8:00 a.m. – 7:30 p.m.</td>
               </tr>
               <tr>
                 <td>Scholarship/Grants and Student Aid</td>
                 <td>7330</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Special Events and Hospitality</td>
                 <td>7782</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Stores and Transportation</td>
                 <td>7103</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>Student Services</td>
                 <td>7226</td>
                 <td>8:30 a.m. – 4:00 p.m.</td>
               </tr>
               <tr>
                 <td>Student Finance</td>
                 <td>7224</td>
                 <td>8:30 a.m. – 4:00 p.m.</td>
               </tr>
               <tr>
                 <td>UNISS</td>
                 <td>7300</td>
                 <td>8:00 a.m. – 5:00 p.m.</td>
               </tr>
               <tr>
                 <td>University Records</td>
                 <td>7262</td>
                 <td>Mon - Wed: 8:30 a.m. – 4:45 p.m. <br> Thurs: 8:30 a.m - 12:00 p.m</td>
               </tr>
               <tr>
                 <td>University Relations</td>
                 <td>7152</td>
                 <td>8:30 a.m. – 5:00 p.m.</td>
               </tr>

               </tbody>
             </table>
           </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
    export default {
        name: "openingHours",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Office Hours',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Office and department opening hours at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){



    h1{
      font-size: 1.4em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }


  }
</style>
